<template>
  <section>
    <back-button/>
    <h1>{{ $t('requestExchangeConfirm.title') }}</h1>
    <panel class="req-x-confirm-panel">
      <p class="value-title"><strong>{{ $t('requestExchangeConfirm.amountToExchange') }}</strong></p>
      <p class="amount-wrapper">
        <span class="amount">{{ numberFormat(requestAmount) }}</span> {{ $t('jewelUnit') }}
      </p>
      <p class="value-title"><strong>{{ $t('requestExchangeConfirm.balanceAfterExchange') }}</strong></p>
      <div class="formula-wrapper">
        <div class="formula">
          <div class="obj">
            <p class="label">{{ $t('requestExchangeConfirm.currentBalance') }}</p>
            <p class="num">{{ numberFormat(userJewelBalance) }}</p>
          </div>
          <p class="operator">-</p>
          <div class="obj">
            <p class="label">{{ $t('requestExchangeConfirm.formulaAmountToExchange') }}</p>
            <p class="num">{{ numberFormat(requestAmount) }}</p>
          </div>
          <p class="operator">=</p>
          <div class="obj">
            <p class="label">{{ $t('requestExchangeConfirm.subtractedBalance') }}</p>
            <p class="num">{{ numberFormat(userJewelBalance - requestAmount) }}</p>
          </div>
        </div>
        <p class="note">{{ $t('requestExchangeConfirm.mayNotBeLatest') }}</p>
      </div>

      <hr>

      <p>{{ $t('requestExchangeConfirm.areYouSure') }}</p>
      <div class="actions">
        <p class="correct-link"><a href="#" @click="onCorrectButtonClick">{{ $t('requestExchangeConfirm.doCorrect') }}</a></p>
        <div class="submit">
          <enlil-button :block="true" :disabled="isSending" @click="onSubmitButtonClick">
            <div v-if="isSending" class="lw-wrap">
              <loading-wheel/>
              <div class="lw-desc">{{ $t('requestExchangeConfirm.submitting') }}</div>
            </div>
            <div v-else>{{ $t('requestExchangeConfirm.doRequest') }}</div>
          </enlil-button>
        </div>
        <p v-if="isSendError" class="error">{{ $t('requestExchangeConfirm.error') }}</p>
      </div>
    </panel>
  </section>
</template>

<style lang="scss" scoped>
@import "../../styles/media_query_mixins.scss";

.error {
  font-size: 0.8em;
  color: #990000;
}

.req-x-confirm-panel {
  max-width: 640px;
  margin-left: auto;
  margin-right: auto;
}

.value-title {
  margin: 1em 0 0.5em 0;
}

.amount-wrapper {
  margin: 0 0 2em 0;
}

.amount {
  margin: 0.3em 0;
  font-size: 3em;
}
.actions {
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  @include size-lg {
    flex-direction: row;

    .submit {
      width: initial !important;
    }
  }

  .correct-link {
    color: #404040;
    text-align: center;

    a {

      @include size-lg {
        border-bottom: #000 1px dotted;
      }

      &, &:hover, &:active, &:visited {
        color: inherit;
        text-decoration: inherit;
      }
    }
  }
  .submit {
    width: 100%;
  }
}

.formula-wrapper {
  .formula {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .operator {
      margin: 0 0.7em;
      font-size: 1.2em;
    }
    .obj {
      display: flex;
      flex-direction: column;
      align-items: center;

      .label, .num {
        margin: 0;
      }

      .label {
        font-size: 0.7em;
        font-weight: bold;
        color: #999;
      }

      .num {
        font-size: 1.5em;
      }
    }
  }

  .note {
    font-size: 0.6em;
    color: #999;
  }
}

.lw-wrap {
  display: flex;
  align-items: center;
  justify-content: center;

  .lw-desc {
    margin-left: 0.5em;
  }
}
</style>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import BackButton from '../../components/BackButton.vue'
import EnlilButton from '../../components/EnlilButton.vue'
import LoadingWheel from '../../components/LoadingWheel.vue'
import Panel from '../../components/Panel.vue'

export default {
  name: 'request-exchange-confirm',
  components: {
    BackButton,
    EnlilButton,
    LoadingWheel,
    Panel
  },
  computed: {
    ...mapGetters('requestForm', ['isSufficient']),
    ...mapState('requestForm', ['requestAmount', 'isSending', 'isSent', 'isSendError']),
    ...mapState('currentUserInfo', { userJewelBalance: 'jewelBalance', userIsBelongingToAgency: 'isBelongingToAgency' })
  },
  mounted () {
    if (this.userIsBelongingToAgency) {
      this.$router.replace('/')
      return
    }

    if (!this.isSufficient) {
      this.$router.replace('/request_exchange')
    }
  },
  methods: {
    ...mapActions('requestForm', ['submit']),
    numberFormat (num) {
      return (num || 0).toLocaleString()
    },
    onCorrectButtonClick (e) {
      this.$router.push('/request_exchange')
    },
    async onSubmitButtonClick (e) {
      await this.submit()
      if (this.isSent && !this.isSendError) {
        this.$router.push('/request_exchange_complete')
      }
    }
  }
}
</script>
